/**
 * Organisation console (CUJ-84) — replaces the low-level Access Control tab.
 *
 * Two modes over the org-hierarchy REST API: the location tree (units, who works
 * where, which patients sit where) and the role catalogue (functions, members,
 * resource grants). A segmented control switches between them; each mode is a
 * self-contained master-detail view.
 *
 *
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@/components/ui/segmented-control';
import { LocationsView } from './LocationsView';
import { RolesView } from './RolesView';

type Mode = 'locations' | 'roles';

export function OrgConsole() {
  const { t } = useTranslation();
  const [mode, setMode] = useState<Mode>('locations');

  return (
    <div className="space-y-4">
      <SegmentedControl
        value={mode}
        onChange={(v) => setMode(v as Mode)}
        options={[
          { id: 'locations', label: t('org.console.locations', 'Locations') },
          { id: 'roles', label: t('org.console.roles', 'Roles') },
        ]}
      />
      {mode === 'locations' ? <LocationsView /> : <RolesView />}
    </div>
  );
}
